import {
  IPayeeTaxFormResponse,
  TaxFormCorrectionStatus
} from "@wingspanhq/payments/dist/interfaces";

export const selectorPayeeTaxFormPayeeCorrectionIsAccepted = (
  taxForm: IPayeeTaxFormResponse
) => {
  if (taxForm.corrections?.length) {
    const latestCorrection =
      taxForm.corrections[taxForm.corrections.length - 1];

    // is accepted and created by member
    return latestCorrection.status === TaxFormCorrectionStatus.Submitted;
  }

  return false;
};
